<template>
  <div class="loading-spinner">
    <svg class="animate-spin h-6 w-6 text-blue-500" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" />
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
    </svg>
  </div>
</template>
<script setup lang="ts">
// Basic loading spinner stub
</script>
<style scoped>
.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
